import usePrivateAxios from "@/common/api/usePrivateAxios";
import { useMutation } from "@tanstack/react-query";

interface UseUpdateSupplyPolitics {
  companyId?: string
  onSuccess?: (response: any) => void
  onError?: (error: any) => void
}

export const useUpdateSupplyPolitics = ({ companyId, onSuccess, onError }: UseUpdateSupplyPolitics) => {
  const privateAxios = usePrivateAxios()

  return useMutation({
    mutationKey: ['updateSupplyPolitics'],
    mutationFn: async (passwordRestriction: string) => {
      await privateAxios.put(`/client/companies/${companyId}`, {
        consumption_password_update_restriction: passwordRestriction,
      })
    },
    onSuccess,
    onError,
  })
}